class Common {
  _init = async () => {
    return true
  }

  setTvWindowSize = async (position, force) => {
    if (__.source.isPlatformSource() && !__.media.isPlaying() && !force) return true

    const promise = await _$.progress.create()

    /* Library Code */
    hcap.video.setVideoSize({
      x: position.x,
      y: position.y,
      width: position.width,
      height: position.height,
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    return promise.done
  }
}

export default Common
